// src/components/ui/Btn.js
import React from 'react';
import { Loader } from 'lucide-react';

const Btn = ({
  children,
  v = 'primary',
  onClick,
  className = '',
  icon: I,
  disabled,
  loading,
  type = 'button',
}) => {
  const s = {
    primary:
      'bg-gradient-to-r from-rose-500 to-fuchsia-600 text-white shadow-lg hover:shadow-xl hover:scale-[1.02]',
    outline:
      'bg-white border-2 border-rose-400 text-rose-600 hover:bg-rose-50 dark:bg-gray-800 dark:border-rose-500 dark:text-rose-400 dark:hover:bg-gray-700',
    ghost: 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800',
    white: 'bg-white text-rose-600 shadow-lg hover:shadow-xl dark:bg-gray-800 dark:text-rose-400',
  };
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`px-5 py-2.5 rounded-full font-bold transition-all active:scale-95 flex items-center justify-center gap-2 disabled:opacity-50 ${s[v]} ${className}`}
    >
      {loading ? <Loader size={18} className="animate-spin" /> : I && <I size={18} />}
      {children}
    </button>
  );
};

export default Btn;
